import clsx from 'clsx';
import Tooltip from '@components/Tooltip/PopperTooltip';

type InputLabelProps = {
  name?: string;
  formRowName?: string;
  label: string | React.ReactNode;
  smallLabel?: boolean;
  className?: string;
  children?: any;
  required?: boolean;
  hoverHint?: any;
  hoverHintMode?: 'hover' | 'click';
  style?: any;
  subText?: string | React.ReactNode;
};

export default function InputLabel({
  name = '',
  formRowName = '',
  label,
  smallLabel = false,
  className = '',
  children = undefined,
  required = false,
  hoverHint = null,
  hoverHintMode = 'hover',
  style = {},
  subText = '',
}: InputLabelProps) {
  return (
    <div
      className={clsx(
        'group-[.dynamic-fields]:[&:has(+_input)]:tw-mb-1',
        className
      )}
    >
      {/* Horizontal row for label + tooltip */}
      <div className="tw-flex tw-items-center">
        <label
          className={clsx({
            'nsw-form__label': true,
            'nsw-form__label--small': smallLabel,
            'nsw-form__required': label && required,
            'tw-flex': children,
            'tw-sr-only': formRowName,
          })}
          htmlFor={name || undefined}
          id={name ? `${name}-label` : undefined}
          style={style}
        >
          {formRowName && `${formRowName} `}
          {label}
          {children && <span>{children}</span>}
        </label>

        {hoverHint && (
          <Tooltip buttonClassName="tw-ml-2" mode={hoverHintMode}>
            {hoverHint}
          </Tooltip>
        )}
      </div>

      {/* Subtext should now appear below the label row */}
      {subText && (
        <div className="tw-text-xs tw-text-gray-500 tw-mt-0.5">
          {subText}
        </div>
      )}
    </div>
  );
}
